import { initISWSideEffect } from "../../shared/components/isw-side-effects/create-isw-helpers";
import { MaandlastenBerekeningState } from "./maandlasten-berekening-schema";

export const syncMaandlastenBerekeningSideEffects = initISWSideEffect<MaandlastenBerekeningState>(({ has, draft }) => {
  if (has.uitgangspunten.changed) {
    draft.dataHasChanged = true;
  }
})();
